/**
 * Back/forward cache on the Steam import screens.
 *
 * Every screen of this flow reads its state from the server and none of it lives in the page, so a
 * DOM restored from the back/forward cache is a photograph of a decision that may since have moved.
 * Two of those are wrong in a way the reader cannot see:
 *
 * - `Import rules` restored after a trip to `Manage statuses` shows the select without the status that
 *   trip just created, so the link the screen offers leads nowhere.
 * - `Review` restored after the rules were cleared elsewhere - another tab, a browser Back over a
 *   selection change - still offers `Start import`, and that button is the write.
 *
 * So it is hooked on the flow rather than on a link. Narrowing it to the Dictionaries link would leave
 * the browser Back button, a second tab and `Back to review` restoring the same stale page, and the
 * worse of the two cases is the one with no link involved at all.
 *
 * `event.persisted` is the whole test: a normal load reports false and is left alone.
 */
const PAGE_VIEWS = ['steam-import', 'steam-import-rules'];

export function initSteamImportBfcache(
    documentRef = globalThis.document,
    windowRef = globalThis,
    reload = () => globalThis.location?.reload?.(),
) {
    // Duck-typed like every other module on these screens: this file is imported into a bundle that
    // also loads where no document exists at all.
    const selector = PAGE_VIEWS.map((view) => `[data-page-view="${view}"]`).join(',');
    if (typeof documentRef?.querySelector !== 'function' || documentRef.querySelector(selector) === null) {
        return undefined;
    }

    if (typeof windowRef?.addEventListener !== 'function') {
        return undefined;
    }

    const onPageShow = (event) => {
        if (event?.persisted === true) {
            reload();
        }
    };

    windowRef.addEventListener('pageshow', onPageShow);

    return onPageShow;
}

initSteamImportBfcache();
